export function drawHeader(doc, month, year, title) {
  // Do nothing if title is not provided
  if (!title || !String(title).trim()) {
    return;
  }

  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();

  const isPortrait = height > width;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(isPortrait ? 10 : 14);

  doc.text(
    `${title} for the month of ${month} - ${year}`,
    width / 2,
    12,
    { align: "center" }
  );

  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
}